export default __webpack_public_path__ + "static/media/Minicard_7h.96558557.svg";